import type { ReportConfigSchema } from "@/features/reports/model/report-registry-types"

export type ReportConfigValues = Record<string, string>

/** Serialize collected config values to a query string for the /view route (deep-linkable, refresh-safe). */
export function configToSearchParams(values: ReportConfigValues): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(values)) {
    if (value) params.set(key, value)
  }
  return params.toString()
}

/** Read config values back from the URL, keyed by the schema's field keys. */
export function parseConfigFromParams(searchParams: URLSearchParams, schema?: ReportConfigSchema): ReportConfigValues {
  const values: ReportConfigValues = {}
  for (const field of schema?.fields ?? []) {
    const value = searchParams.get(field.key)
    if (value) values[field.key] = value
  }
  return values
}

/** True when every required field in the schema is present in the values. */
export function isConfigComplete(values: ReportConfigValues, schema?: ReportConfigSchema): boolean {
  return (schema?.fields ?? []).every((field) => !field.required || Boolean(values[field.key]))
}
